<div class="add-container">
    <h1 class="add-title">Adaugă operator</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Nume</mat-label>
                    <input type="text" matInput formControlName="name" />
                    <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip Operator</mat-label>
                    <mat-select formControlName="type">
                        <mat-option *ngFor="let type of userTypes" [value]="type.id">
                            {{ type.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['type'].valid && form.controls['type'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Direcție</mat-label>
                    <mat-select formControlName="id_directie" (selectionChange)="onDirectieChange($event.value)">
                        <mat-option value="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let directie of directiiActive" [value]="directie.id">
                            {{ directie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_directie'].valid && form.controls['id_directie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Compartiment</mat-label>
                    <mat-select formControlName="id_compartiment"
                        (selectionChange)="onDirectieCompartimentChange($event.value)">
                        <mat-option value="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let compartiment of compartimenteActive$ | async" [value]="compartiment.id">
                            {{ compartiment.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['id_compartiment'].valid && form.controls['id_compartiment'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Operator</mat-label>
                    <input type="text" matInput formControlName="user" [matAutocomplete]="auto" />
                    <mat-icon matSuffix class="opacity-50">search</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngIf="usersActive$.length == 0">No results found</mat-option>
                        <mat-option *ngFor="let user of filteredActiveUsers" [value]="user.name"
                            (onSelectionChange)="onActiveUsersChange(user)">
                            {{ user.name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Observații</mat-label>
                    <input type="text" matInput formControlName="observations" />
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>